/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slim_Vivid_Goose_TiltInputs */

const en_slim_vivid_goose_tilt = /** @type {(inputs: Slim_Vivid_Goose_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deleting content...`)
};

const de_slim_vivid_goose_tilt = /** @type {(inputs: Slim_Vivid_Goose_TiltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lösche Inhalt...`)
};

/**
* | output |
* | --- |
* | "Deleting content..." |
*
* @param {Slim_Vivid_Goose_TiltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slim_vivid_goose_tilt = /** @type {((inputs?: Slim_Vivid_Goose_TiltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slim_Vivid_Goose_TiltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_slim_vivid_goose_tilt(inputs)
	return de_slim_vivid_goose_tilt(inputs)
});